import Taro from '@tarojs/taro'
import {
  getLocalStorage,
  STORE_KEYS,
  userID,
  removeLocalStorage
} from '@/tool/localStore';



// 判断用户是否存在用户id,主要是用在ai，作为唯一的key
export function isuserIDpresent() {
  let _userID: string | null = getLocalStorage(userID);
  console.log('_userID', _userID);
  if (!_userID) {
    // 清除token
    removeLocalStorage(STORE_KEYS.token);
    // 如果不存在让用户重新登录
    Taro.reLaunch({
      url: `/pages/authority-center/index?flag=0`,
    });
  }
};

// 用户是否登录
export function userIsLogin() {
  return getLocalStorage(STORE_KEYS.token)
}

// 获取基地id
export function getBaseId() {
  return userStore.getBaseId
}